function dateFormatter(date) {
    return new Date(date).toDateString();
}
function wordArrayFormatter(words) {
    if (words instanceof Array) {
        return words.length <= 1
            ? words.slice(-1)
            : `${words.slice(1).join(', ')} and ${words.slice(-1)}`;
    }
    return words;
}
function getNameById(mapArray, id) {
    const foundObj = mapArray.find((elem) => parseInt(elem.id, 10) === id);
    return foundObj ? foundObj.name : `${id}`;
}
function interestListFormatter(interestArrayString, interestMap) {
    try {
        const interestArray = JSON.parse(interestArrayString);
        const parsedInterests = interestArray.map((interestID) => getNameById(interestMap, interestID));
        // return wordArrayFormatter(parsedInterests);
        return parsedInterests;
    }
    catch (err) {
        console.warn('Expected JSONstring but got:', interestArrayString);
    }
    return [interestArrayString];
}
const MyJSON = {
    parse: (str) => {
        try {
            return JSON.parse(str);
        }
        catch (e) {
            // console.warn(e);
            return str;
        }
    },
    stringify: (value) => {
        try {
            return JSON.stringify(value);
        }
        catch (e) {
            // console.warn(e);
            return value;
        }
    }
};
function numToRedGreen(value, opacity = 0.3) {
    //value from 0 to 1; red to green
    const hue = (value * 120).toString(10);
    return `hsla(${hue}, 95%, 50%, ${opacity})`;
}
function asyncTimeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export { MyJSON, numToRedGreen, asyncTimeout, dateFormatter, wordArrayFormatter, interestListFormatter };
